<template>
  <el-tabs ref="pageTabs"
    :type="borderStyle ? 'border-card' : ''"
    :value="defaultTabName"
    @tab-click="toggleTab">

    <el-tab-pane
      v-for="item in validTabs"
      :key="item.name"
      :label="item.label"
      :name="item.name">
      <slot :name="item.name"></slot>
    </el-tab-pane>

  </el-tabs>
</template>

<script>
export default {
  props: {
    borderStyle: {
      type: Boolean,
      default: false
    },
    tabs: {
      type: Array,
      default: [ // eslint-disable-line vue/require-valid-default-prop
      ]
    }
  }, // end of props
  computed: {
    validTabs() {
      if (!this.tabs) return [];
      return this.tabs.filter(item => !item.disabled);
    },
    defaultTabName() {
      if (!this.validTabs.length) return null;
      const dItem = this.validTabs.filter(item => item.isDefault);
      if (!dItem.length) return this.validTabs[0].name;
      return dItem[0].name;
    }
  },
  methods: {
    toggleTab() {
      const { currentName } = this.$refs.pageTabs;
      const tabItem = this.validTabs.filter(item => item.name === currentName)[0];
      if (this.$router && tabItem.route) {
        const { path, query } = tabItem.route;
        this.$router.push({ path, query });
      }
      this.$emit('toggle', currentName); // <page-tabs @toggle="..." />
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/PageTabs.vue